import _ from 'lodash';
import getHelpers from '../helpers';
const api = getHelpers('api');

// initial state
const state = {
    ...window.store,
    notifications: [],
    timestamp: Date.now(),
}

// getters
const getters = {
    customer: (state) => state.customer,
    customerLogin: (state) => state.customerLogin,
    cart: (state) => state.cart,
    notifications: (state) => state.notifications,
    timestamp: (state) => state.timestamp,
    pathNodes: (state) => state.pathNodes,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    }
}

const actions = {
    registerCustomer({ commit }, data) {
        return api
            .postData(`/../register`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Your account has been created',
                });
                commit('updateProfile', res);
                return res;
            })
    },

    updateProfile({ commit }, data) {
        return api
            .patchData(`/my/profile`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Profile update success',
                });
                commit('updateProfile', res);
                return res;
            })
    },

    updateCustomer({ commit, state }, data) {
        const customerId = _.get(state, 'customer.id');
        return api
            .patchData(`/my/customer/${customerId}`, {}, { origin: data })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Profile update success',
                });
                commit('updateCustomer', res);
            })
    },

    createOrder({ commit }, data) {
        return api.postData(`/my/orders`, {}, data)
            .then(res => {
                // commit('addNotification', {
                //     type: 'message',
                //     message: 'Your order is ready',
                // });
                commit('setOrder', res);
                return res;
            })
    },

    updateOrder({ commit }, data) {
        return api.patchData(`/my/orders/${data.id}`, {}, data)
            .then(res => {
                // commit('addNotification', {
                //     type: 'message',
                //     message: 'Your order is ready',
                // });
                commit('setOrder', res);
                return res;
            })
    },

    setCart({ commit }, cart) {
        return api
            .getData(`/my/cart`, {
                cart_id: cart.id,
                include: 'items',
            })
            .then(res => {
                commit('setCart', res);
                return res;
            })
    },

    setCartItems({ commit }, cartItems) {
        commit('setCartItems', cartItems);
    },

    updateCart({ commit }, data) {
        return api
            .patchData(`/my/cart`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Cart updated successfully',
                });
                commit('updateCart', res);
                return res;
            })
    },

    updateCartDryrun({ commit }, data) {
        return api
            .patchData(`/my/cart`, {}, { ...data, dryrun: 1 })
            .then(res => {
                commit('updateCartAttributes', res);
                return res;
            })
    },

    updateCartById({ commit }, input) {
        const id = _.get(input, 'id');
        const data = _.get(input, 'data', {});

        return api
            .patchData(`/my/carts/${id}`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Cart updated successfully',
                });
                // commit('updateCart', res);
                return res;
            })
    },

    createCart({ commit }, data) {
        return api
            .postData(`/my/carts`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'New cart has been created',
                });
                commit('createCart', res);
                return res;
            })
    },

    deleteCart({ commit }, id) {
        return api
            .delData(`/my/cart/${id}`)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Cart has been deleted',
                });
                commit('deleteCart', res);
                return res;
            })
    },

    getCartItems({ commit }, payload) {
        const { cart_id } = payload;
        return api.getData(`/my/cart/items`, { cart_id, per_page: 9999999, rawparent: true, exclude: 'product.code_price,product.search,product.category_list,product.full_category_paths,product.categories,product.brand' })
            .then(res => {
                commit('setCartItems', res);
                return res;
            })
    },

    createCartItem({ commit }, payload) {
        const { cart_id, item } = payload;

        return api.postData(`/my/cart/items?norelation&noparent`, {}, _.merge({ cart_id }, _.get(item, 'attributes', {})))
            .then(() => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'message',
                        message: 'Item has been added to your cart.',
                    });
                }
                return api.getData(`/my/cart/items`, {
                    cart_id,
                    per_page: 9999999,
                    rawparent: true,
                    exclude: 'product.code_price,product.search,product.category_list,product.full_category_paths,product.categories,product.brand'
                });
            })
            .then(res => {
                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('setCartItems', res);

                const newCartItem = _.find(res.data,
                    (cartItem) => _.get(cartItem, 'attributes.price_id') == _.get(item, 'attributes.price_id')
                );
                commit('setNewCartItem', newCartItem);

                trackingEvent('cart.item.create', {
                    item: _.get(newCartItem, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                });

                return res;
            })
            .catch(e => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'error',
                        title: 'Sorry',
                        message: _.get(e, 'response.data.message', 'Something went wrong.'),
                    });
                }

                throw e;
            });
    },

    createCartItems({ commit }, payload) {
        let { cart_id, data } = payload;
        data = _.map(data, (d) => {
            return {
                ...d,
                '$create': {
                    ...d['$create'],
                    cart_id
                }
            }
        });

        return api.putData(`/my/cart/multi`, {}, {data})
            .then(() => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'message',
                        message: 'Items have been added to your cart.',
                    });
                }
                return api.getData(`/my/cart/items`, {
                    cart_id,
                    per_page: 9999999,
                    rawparent: true,
                    exclude: 'product.code_price,product.search,product.category_list,product.full_category_paths,product.categories,product.brand'
                });
            })
            .then(res => {
                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('setCartItems', res);

                return res;
            })
            .catch(e => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'error',
                        title: 'Sorry',
                        message: _.get(e, 'response.data.message', 'Something went wrong.'),
                    });
                }

                throw e;
            });
    },

    createCartPromoItem({ commit }, payload) {
        const { cart_id, data } = payload;

        return api.putData(`/carts/${cart_id}/promo`, {}, {data})
            .then(() => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'message',
                        message: 'Promotion has been added to your cart.',
                    });
                }
                return api.getData(`/my/cart/items`, {
                    cart_id,
                    per_page: 9999999,
                    rawparent: true,
                    exclude: 'product.code_price,product.search,product.category_list,product.full_category_paths,product.categories,product.brand'
                });
            })
            .then(res => {
                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('setCartItems', res);

                return res;
            })
            .catch(e => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'error',
                        title: 'Sorry',
                        message: _.get(e, 'response.data.message', 'Something went wrong.'),
                    });
                }

                throw e;
            });
    },

    updateCartItem({ commit }, payload) {
        const { cart_id, item } = payload;

        return api.patchData(`/my/cart/item/${item.id}`, {norelation: true, rawparent: true}, _.merge({ cart_id }, _.get(item, 'attributes', {})))
            .then(res => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'message',
                        message: 'Item has been updated.',
                    });
                }

                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('updateCartItems', [
                    { id: res.id, $updated: res }
                ]);

                trackingEvent('cart.item.update', {
                    item: _.get(res, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                });

                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Something went wrong.'),
                });

                // refresh cart here
                api.getData(`/my/cart`, {
                    cart_id: cart_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateCart', res);
                })

                throw e;
            });
    },

    deleteCartItem({ commit }, payload) {
        const { cart_id, item } = payload;
        return api.delData(`/my/cart/item/${item.id}`, { cart_id, norelation: true, rawparent: true })
            .then(res => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'message',
                        message: 'Item has been removed.',
                    });
                }

                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('updateCartItems', [
                    { id: res.id, $deleted: true }
                ]);

                trackingEvent('cart.item.delete', {
                    item: _.get(res, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                });

                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Something went wrong.'),
                });

                // refresh cart here
                api.getData(`/my/cart`, {
                    cart_id: cart_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateCart', res);
                })

                throw e;
            });
    },

    deleteCartPromo({ commit }, payload) {
        const { cart_id, item, data } = payload;

        return api.putData(`/carts/${cart_id}/items`, {}, { data })
            .then(() => api.getData(`/my/cart/items`, { cart_id, per_page: 9999999, rawparent: true, exclude: 'product.code_price,product.search,product.category_list,product.full_category_paths,product.categories,product.brand' }))
            .then(res => {
                if (_.get(payload, 'notification', true)) {
                    commit('addNotification', {
                        type: 'message',
                        message: 'Item has been removed.',
                    });
                }

                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('setCartItems', res);

                trackingEvent('cart.item.delete', {
                    item: _.get(res, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                });

                return res;
            })
            .catch((e) => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Something went wrong.'),
                });

                // refresh cart here
                api.getData(`/my/cart`, {
                    cart_id: cart_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateCart', res);
                })

                throw e;
            });
    },

    addNotification({ commit }, payload) {
        commit('addNotification', payload);
    },

    createDeliveryAddress({ commit }, data) {
        return api.postData('/delivery_addresses', {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Delivery address created successfully',
                });
                commit('addDeliveryAddress', res);
                return res;
            })
    },

    updateDeliveryAddresses({ commit }, payload) {
        const { data } = payload;

        return api.putData('/delivery_addresses', {}, { data })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Delivery address updated successfully',
                });
                commit('updateDeliveryAddresses', res);
                return res;
            })
    },
}

// mutations
const mutations = {
    setCart(state, cart) {
        _.set(state, 'cart', cart);
    },

    setCartAttribute(state, cart) {
        const attributes = _.chain(state).get('cart.attributes').merge(_.get(cart, 'attributes', {})).value();
        _.set(state, 'cart.attributes', attributes);
        _.set(state, 'timestamp', Date.now());
    },

    setOrder(state, order) {
        _.set(state, 'order', order);
        _.set(state, 'timestamp', Date.now());
    },

    setProduct(state, response) {
        _.set(state, 'product', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateProfile(state, response) {
        _.set(state, 'customer', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateCustomer(state, response) {
        _.set(state, 'customer', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateCart(state, response) {
        let cartItems = _.get(state, 'cart.included.items');
        _.set(state, 'cart', response);
        _.set(state, 'cart.included.items', cartItems);
        _.set(state, 'timestamp', Date.now());
    },

    updateCartAttributes(state, response) {
        _.set(state, 'cart.attributes', _.get(response, 'attributes', {}));
        _.set(state, 'timestamp', Date.now());
    },

    createCart(state, response) {
        const carts = _.get(state, 'carts.data', []);
        _.set(state, 'carts.data', _.concat(carts, [response]));
        _.set(state, 'timestamp', Date.now());
    },

    deleteCart(state, response) {
        const carts = _.get(state, 'carts.data', []);
        _.set(state, 'carts.data', _.reject(carts, (c) => c.id == response.id));
        _.set(state, 'timestamp', Date.now());
    },

	setCartItems(state, response) {
        _.set(state, 'cart.included.items', response);
        _.set(state, 'timestamp', Date.now());
	},

    setNewCartItem(state, response) {
        _.set(state, 'newCartItem', response);
    },

    updateCartItems(state, data) {
        let items = _.get(state, 'cart.included.items.data', []);

        _.forEach(data, (item) => {
            /*||*/ if (_.has(item, '$created')) {
                items = _.concat(items, item.$created);

            } else if (_.has(item, '$updated')) {
                const idx = _.findIndex(items, (it) => it.id == item.id);
                items[idx] = item.$updated;

            } else if (_.has(item, '$deleted')) {
                items = _.reject(items, (it) => it.id == item.id);
            }
        })

        _.set(state, 'cart.included.items.data', items);
        _.set(state, 'timestamp', Date.now());
    },

    addDeliveryAddress(state, response) {
        let data = _.get(state, 'customer.included.delivery_addresses.data', []);
        data = _.concat(data, response);

        _.set(state, 'customer.included.delivery_addresses.data', data);
        _.set(state, 'timestamp', Date.now());
    },

    updateDeliveryAddresses(state, response) {
        const { created, updated, deleted, attached, detached } = response.meta;

        let data = _.get(state, 'customer.included.delivery_addresses.data', []);

        // replacing updated items
        data = _.map(data, item => {
            const replacingItem = _.find(response.data, (itemData => itemData.id == item.id));
            return replacingItem || item;
        });

        // filter out deleted items
        data = _.filter(data, item => {
            return _.indexOf(deleted, item.id) < 0;
        });

        // add items created
        data = _.concat(data, _.filter(response.data, item => _.indexOf(created, item.id) >= 0));

        // add items attached
        data = _.concat(data, _.filter(response.data, item => _.indexOf(attached, item.id) >= 0));

        // filter out detached items
        data = _.filter(data, item => _.indexOf(detached, item.id) < 0);

        _.set(state, 'customer.included.delivery_addresses.data', data);
        _.set(state, 'timestamp', Date.now());
    },

    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
